import { createContext, useContext, useState } from 'react';

interface IMutationModalContext {
  data: unknown;
  showDeleteModal: boolean;
  showUpdateModal: boolean;
  showUpdatePermissionModal: boolean;
  showPasswordModal: boolean;
  showDeactivateModal: boolean;
  showRejectModal: boolean;
  setData: React.Dispatch<React.SetStateAction<unknown>>;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowUpdatePermissionModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowPasswordModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowDeactivateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowRejectModal: React.Dispatch<React.SetStateAction<boolean>>;
}

// creating the update modal utility context here
const MutationModalContext = createContext<IMutationModalContext | null>(null);

const MutationModalProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [data, setData] = useState<unknown>();

  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
  const [showUpdatePermissionModal, setShowUpdatePermissionModal] =
    useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  const [showRejectModal, setShowRejectModal] = useState<boolean>(false);
  const [showDeactivateModal, setShowDeactivateModal] =
    useState<boolean>(false);

  // rendering the context provider here
  return (
    <MutationModalContext.Provider
      value={{
        data,
        showDeleteModal,
        showUpdateModal,
        showUpdatePermissionModal,
        showPasswordModal,
        showDeactivateModal,
        showRejectModal,
        setData,
        setShowDeleteModal,
        setShowUpdateModal,
        setShowUpdatePermissionModal,
        setShowPasswordModal,
        setShowDeactivateModal,
        setShowRejectModal,
      }}
    >
      {children}
    </MutationModalContext.Provider>
  );
};

export default MutationModalProvider;

// creating custom hook to access the mutation modal context here
export const useMutationModalContext = () => {
  const context = useContext(MutationModalContext);

  if (!context) {
    throw new Error(
      'useMutationModalContext must be within MutationModalProvider!'
    );
  }

  return context;
};
